import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getVariantsEditorUrl } from 'personalization-lib/utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const ManageVariantsLink = ({
  label,
  strategyId
}) => /*#__PURE__*/_jsx(Button, {
  use: "link",
  href: getVariantsEditorUrl(strategyId),
  external: true,
  "data-test-id": "manage-variants-link",
  children: label !== null && label !== void 0 ? label : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "personalizationLib.shared.manageVariants"
  })
});
export default ManageVariantsLink;